// src/App.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import SignupPage from './pages/SignupPage';
import LoginPage from './pages/LoginPage';
import TenantDashboard from './pages/TenantDashboard';
import BrowsePage from './pages/BrowsePage';
import ProtectedRoute from './components/ProtectedRoute';
import HouseDetailPage from './pages/HouseDetailPage';
import AdminDashboard from './components/admin/AdminDashboard';
import AdminLogin from './components/admin/AdminLogin';
import ApplyPage from './pages/ApplyPage';
import FAQPage from './pages/Faqpage';
import WaitlistPage from './pages/WaitlistPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import HowItWorksPage from './pages/HowItWorksPage';
import GoogleCallbackPage from './pages/GoogleCallbackPage';
import {
  TenantGuidePage,
  TermsPage,
  PrivacyPage,
  AgreementsPage,
  HelpCenterPage,
} from './pages/StaticPages';
import ScrollToTop from './components/ScrollToTop';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import SeoLandingPage from './pages/SeoLandingPage';
import SeoGuidesHubPage from './pages/SeoGuidesHubPage';

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/login" element={<LoginPage />} />

        {/* Google OAuth callback — handles mobile redirect after Google sign-in */}
        <Route path="/auth/google/callback" element={<GoogleCallbackPage />} />

        {/* Protected Tenant Routes */}
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <TenantDashboard />
          </ProtectedRoute>
        } />
        <Route path="/browse" element={<BrowsePage />} />
        <Route path="/apply" element={
          <ProtectedRoute>
            <ApplyPage />
          </ProtectedRoute>
        } />
        <Route path="/house/:id" element={<HouseDetailPage />} />

        {/* Admin Routes */}
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/login" element={<AdminLogin />} />

        <Route path="/faq" element={<FAQPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/how-it-works" element={<HowItWorksPage />} />
        <Route path="/tenant-guide" element={<TenantGuidePage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/agreements" element={<AgreementsPage />} />
        <Route path="/help" element={<HelpCenterPage />} />
        <Route path="/waitlist" element={<WaitlistPage />} />
        <Route path="/interest-form" element={<WaitlistPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/ibadan-rent-guides" element={<SeoGuidesHubPage />} />
        <Route path="/rent-in-ibadan" element={<SeoLandingPage />} />
        <Route path="/apartments-in-ibadan" element={<SeoLandingPage />} />
        <Route path="/cheap-houses-in-ibadan" element={<SeoLandingPage />} />
        <Route path="/verified-homes-in-ibadan" element={<SeoLandingPage />} />
        <Route path="/2-bedroom-flats-for-rent-in-ibadan" element={<SeoLandingPage />} />
        <Route path="/3-bedroom-houses-for-rent-in-ibadan" element={<SeoLandingPage />} />
        <Route path="/4-bedroom-houses-for-rent-in-ibadan" element={<SeoLandingPage />} />
        <Route path="/houses-for-rent-in-akobo-ibadan" element={<SeoLandingPage />} />
        <Route path="/houses-for-rent-in-bodija-ibadan" element={<SeoLandingPage />} />
        <Route path="/houses-for-rent-in-jericho-ibadan" element={<SeoLandingPage />} />
      </Routes>
    </>
  );
}

export default App;
